// @ts-check

class ProductStickyBar extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form');
    if (!this.form) throw new Error('ProductStickyBar must be a child of a form element');
    this.initIntersectionObserver();
  }

  initIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    };

    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), options);
    this.observer.observe(this.form);
  }

  /**
   * @param {IntersectionObserverEntry[]} entries
   */
  handleIntersection(entries) {
    entries.forEach((entry) => {
      this.classList.toggle('is-sticky', !entry.isIntersecting);
      document.body.classList.toggle('pdp-sticky-atc', !entry.isIntersecting);
    });
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);
